import { render, staticRenderFns } from "./DouMaiKeJiUserFuCha.vue?vue&type=template&id=19231f14&scoped=true&"
import script from "./DouMaiKeJiUserFuCha.vue?vue&type=script&lang=js&"
export * from "./DouMaiKeJiUserFuCha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19231f14",
  null
  
)

export default component.exports